// Toolbar filtri della console Invio Pratiche (estratto move-only, Fase 5).
import { tipoPraticaLabel } from "@/lib/constants";
import { SELECT_CLS, TIPI_PRATICA } from "./invioPratiche.shared";

export interface InvioPraticheFiltriProps {
  query: string; setQuery: (v: string) => void;
  fornitoreFilter: "" | "A2A" | "Sentra" | "Iren";
  setFornitoreFilter: (v: "" | "A2A" | "Sentra" | "Iren") => void;
  statoFilter: string; setStatoFilter: (v: string) => void;
  tipoFilter: string; setTipoFilter: (v: string) => void;
  commodityFilter: string; setCommodityFilter: (v: string) => void;
  dataDa: string; setDataDa: (v: string) => void;
  dataA: string; setDataA: (v: string) => void;
  activeFilters: number; resetFilters: () => void;
}

export function InvioPraticheFiltri(props: InvioPraticheFiltriProps) {
  const { query, setQuery, fornitoreFilter, setFornitoreFilter, statoFilter, setStatoFilter, tipoFilter, setTipoFilter, commodityFilter, setCommodityFilter, dataDa, setDataDa, dataA, setDataA, activeFilters, resetFilters } = props;
  return (
    <>
      {/* Filtri */}
      <div className="flex flex-wrap items-end gap-3">
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">Ricerca</label>
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Cliente, agenzia, offerta..."
            className="h-8 w-56 px-2.5 py-1 text-sm rounded-lg border border-input bg-transparent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50"
          />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">Fornitore</label>
          <select value={fornitoreFilter} onChange={(e) => setFornitoreFilter(e.target.value as "" | "A2A" | "Sentra" | "Iren")} className={SELECT_CLS}>
            <option value="">Tutti</option>
            <option value="A2A">A2A</option>
            <option value="Sentra">Sentra</option>
            <option value="Iren">Iren</option>
          </select>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">Stato</label>
          <select value={statoFilter} onChange={(e) => setStatoFilter(e.target.value)} className={SELECT_CLS}>
            <option value="">Tutti</option>
            <option value="da_inviare">Da inviare</option>
            <option value="in_corso">In corso</option>
            <option value="inviata">Inviata</option>
            <option value="accettata">Accettata</option>
            <option value="attivata">Attivata</option>
            <option value="annullata">Annullata</option>
            <option value="sospesa">Sospesa (no auto-invio)</option>
            <option value="errore">Errore</option>
          </select>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">Tipo</label>
          <select value={tipoFilter} onChange={(e) => setTipoFilter(e.target.value)} className={`${SELECT_CLS} w-48`}>
            <option value="">Tutti</option>
            {TIPI_PRATICA.map((t) => <option key={t} value={t}>{tipoPraticaLabel(t)}</option>)}
          </select>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">Commodity</label>
          <select value={commodityFilter} onChange={(e) => setCommodityFilter(e.target.value)} className={SELECT_CLS}>
            <option value="">Tutte</option>
            <option value="Luce">Luce</option>
            <option value="Gas">Gas</option>
          </select>
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">Da</label>
          <input type="date" value={dataDa} onChange={(e) => setDataDa(e.target.value)} className={SELECT_CLS} />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-[11px] text-muted-foreground">A</label>
          <input type="date" value={dataA} onChange={(e) => setDataA(e.target.value)} className={SELECT_CLS} />
        </div>
        {activeFilters > 0 && (
          <button
            type="button"
            onClick={resetFilters}
            className="h-8 px-3 text-xs border border-border rounded-lg hover:bg-muted transition-colors cursor-pointer text-muted-foreground"
          >
            Azzera filtri ({activeFilters})
          </button>
        )}
      </div>
    </>
  );
}
